export const CardsEnum = {
  contacts: 'contacts',
  detailsContacts: 'detailsContacts',
  detailsProperties: 'detailsProperties',
  openFile: 'openFile',
};
